var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"privacy"}},[(this.isLoading)?_c('LoadingScreen'):_vm._e(),_c('div',{attrs:{"id":"content","attr-sub":this.title}},[_c('section',{staticClass:"title"},[_c('hgroup',[_c('h1',{domProps:{"innerHTML":_vm._s(this.title)}})])]),_c('div',{staticClass:"wrapper"},[_c('div',{domProps:{"innerHTML":_vm._s(this.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }